<template>
  <input
    v-bind="$attrs"
    :id="id"
    :value="value"
    @blur="$emit('input', $event.target.value)"
    @change="$emit('input', $event.target.value)"
    :class="{
      'f-border-red-300 focus:f-ring-red-500 focus:f-border-red-500 f-text-red-900 f-placeholder-red-300':
        error,
    }"
    class="f-form-input f-block f-py-1 f-w-full f-border-gray-300 focus:f-outline-none f-rounded-md f-text-gray-700"
  />
</template>
<script lang="ts">
import Vue from "vue";

export default Vue.extend({
  name: "BaseInput",

  props: {
    id: {
      type: String,
    },
    value: {
      type: String,
      default: "",
    },
    error: {
      type: String,
      default: "",
    },
  },
});
</script>
